//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import _ from 'underscore';

import {
  getUrlWithoutProtocol,
  URL_PROTOCOL_PATTERN_WITH_WWW,
} from '@utils/urlUtils';

import { termsConditionsSettings } from 'app/constants/rights-management/terms-and-conditions-settings';

export function personalizeRightsRequestMessage(
  isIncludeUsernameEnabled: boolean,
  message: string,
  username: string,
): string {
  return isIncludeUsernameEnabled && username.trim().length > 0
    ? `@${username} ${message}`
    : message;
}

export function getMessageWithoutUrl(
  originalMessage: string,
  url: string,
): string {
  const urlWithoutProtocol = getUrlWithoutProtocol(url, true);
  const urlRegex = new RegExp(
    `${URL_PROTOCOL_PATTERN_WITH_WWW}${urlWithoutProtocol}`,
    'i',
  );
  return originalMessage.split(urlRegex)[0]?.trim() ?? originalMessage;
}

/**
 *  The rights request message will include either the short URL or the full URL (sampling campaign rights)
 *  Therefore, the validation should account for both cases.
 */
export const bvTnCUrls: string[] = Object.values(termsConditionsSettings)
  .flatMap(({ url, fullUrl }) => [url, fullUrl])
  .map((url) => getUrlWithoutProtocol(url, true));
